import React, { useState } from "react"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { getContracts, deleteContract } from "../../../api/contract"
import { useParams } from "react-router-dom"
import moment from "moment"
import { Button } from "reactstrap"
import { useHistory } from "react-router-dom"
import { formatCurrency } from "../../../utils/formatCurrency"



export default function ContractsTable({hideTableAction, hideTableHeader}) {

  const { t } = useTranslation()

  const history = useHistory()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,

  } = usePagination(getContracts)

  return (
    <>
      {!hideTableHeader && <TableHeaderHandler
        setPage={setPage}
        setPerPage={setPerPage}
      >
       
      </TableHeaderHandler>}
   
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>ID</Th>
                <Th>Pool Title</Th>
                <Th>Company</Th>

                <Th>Start Date</Th>
                <Th>End Date</Th>
                <Th>Status</Th>
                <Th>Skill Rewards</Th>

                <Th>Pool</Th>
                <Th>Invoiceables</Th>
                <Th>Invoices</Th>

              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.company_contracts.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>
                        {row.id}
                      </Td>
                      <Td>
                        {row.jobTitle}
                      </Td>
                      <Td>
                        {row.company.name}
                      </Td>

                      <Td>{moment(row.startDate).format("DD MMM YYYY")}</Td>
                      <Td>{moment(row.endDate).format("DD MMM YYYY")}</Td>
                      <Td>{row.status}</Td>
                      <Td>{row.skillRewards ? "Yes" : "No"}</Td>
                      <Td>
                        
                        {!row.pool && <Button size="sm" onClick={() => history.push('/add-pool/'+row.id)} color="dark">Add Pool</Button>}
                        {row.pool && <div className="d-flex align-items-center gap-1">
                          <Button size="sm" onClick={() => history.push('/pool-hours/'+row.pool.id)} color="dark">{row.pool.name}</Button>
                          <Button size="sm" onClick={() => history.push('/edit-pool/'+row.pool.id)} color="primary"><i className="bx bx-edit font-size-16 align-middle" /></Button>
                        </div>}

                      </Td>
                      <Td>
                        
                        <Button size="sm" onClick={() => history.push('/contract-invoiceables/'+row.id)} color="dark">
                          View
                        </Button>

                      </Td>
                      <Td>
                        
                        <Button size="sm" onClick={() => history.push('/contract-invoices/'+row.id, {companyName: row.company.name, contractName: row.jobTitle})} color="dark">
                          View
                        </Button>

                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.company_contracts.length === 0} msg="No Contracts Found." />
          }
          
          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}

          <ResultHandler error={error} loading={loading} />


        </div>
      </div>
    </>
  )
}
